// 获取当前环境
const getEnv = () => {
    return process.env.VUE_APP_ENV || 'dev';
};
// 根据环境获取配置
const getEnvConfig = () => {
    const env = getEnv();
    const isDev = env === 'dev';
    return {
        title: process.env.VUE_APP_TITLE,
        apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
        webBaseUrl: process.env.VUE_APP_WEB_BASE_URL,
        baseUrl: process.env.VUE_APP_BACKEND_URL,
        fileServerUrl: process.env.VUE_APP_FILE_SERVER_URL || '',
        downLoadFileUrl: process.env.VUE_APP_DOWNLOAD_FILE_URL || '',
        enableDebug: process.env.VUE_APP_ENABLE_DEBUG === 'true',
        enableErrorLog: process.env.VUE_APP_ENABLE_ERROR_LOG === 'true',
        enablePerformanceMonitor: process.env.VUE_APP_ENABLE_PERFORMANCE_MONITOR === 'true'
    };
};

const envConfig = getEnvConfig();

export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: envConfig.title,
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 1,
    /**
     * @description 是否使用国际化，默认为false
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    useI18n: false,
    /**
     * @description 是否为开发/测试环境（dev/test: true，pro: false）
     */
    devEnvironment: getEnv() !== 'pro',
    /**
     * @description 当前环境
     */
    env: getEnv(),

    apiBaseUrl: envConfig.apiBaseUrl,

    webBaseUrl: envConfig.webBaseUrl,

    /**
     * @description api请求基础路径
     */
    baseUrl: envConfig.baseUrl,
    /**
     * @description 文件服务器地址
     */
    fileServerUrl: envConfig.fileServerUrl,
    /**
     * @description 文件下载地址
     */
    downLoadFileUrl: envConfig.downLoadFileUrl,
    /**
     * @description 是否启用调试工具
     */
    enableDebug: envConfig.enableDebug,
    /**
     * @description 是否启用错误日志收集
     */
    enableErrorLog: envConfig.enableErrorLog,
    /**
     * @description 是否启用性能监控
     */
    enablePerformanceMonitor: envConfig.enablePerformanceMonitor,
    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName: 'home',
    /**
     * @description 需要加载的插件
     */
    plugin: {
        'error-store': {
            showInHeader: false, // 设为false后不会在顶部显示错误日志徽标
            developmentOff: getEnv() === 'dev' // 开发环境不收集错误信息，方便开发中排查错误
        }
    }
};
